import React, { createContext, useContext, useState, useCallback } from "react";

const LangContext = createContext({ lang: "el", toggle: () => {}, setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("taf_lang") || "el");
  const setLang = useCallback((l) => { localStorage.setItem("taf_lang", l); setLangState(l); }, []);
  const toggle = useCallback(() => setLangState((l) => { const n = l === "el" ? "en" : "el"; localStorage.setItem("taf_lang", n); return n; }), []);
  return <LangContext.Provider value={{ lang, toggle, setLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);

// Resolve a label that is either a plain string or an { el, en } object.
export const L = (label, lang) => (typeof label === "string" ? label : (label?.[lang] ?? label?.en ?? ""));
